import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import type { ILinkCard } from './link-card.interface';
import { SdLinkComponent } from '../link/link.component';
import { SdTitleComponent } from '../../title/title.component';
import { ImageRatioEnum } from '../../../_enums/image-ratio.enum';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { SdBannerComponent } from '../../medias/banner/banner.component';

@Component({
  selector: 'sd-link-card',
  templateUrl: './link-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdTitleComponent,
    SdLinkComponent
  ]
})
export class SdLinkCardComponent extends SdThemeComponent {
  @Input()
  linkCard: ILinkCard;

  @Input()
  titleLevel: number;

  @Input()
  isFit = false;

  @Output()
  clicked = new EventEmitter<void>();

  imageRatioEnum = ImageRatioEnum;

  onClick() {
    this.clicked.emit();
  }
}
